export const COUNTRY_ISO2_PATTERN = /^[A-Z]{2}$/;
export const COUNTRY_DISPLAY_NAMES = new Intl.DisplayNames(["en"], {
  type: "region",
  fallback: "none",
});
